require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRawData = setRawData;

var _constants = require('../constants');

function setRawData(component, response) {
  return {
    type: _constants.SET_RAW_DATA,
    component: component,
    response: response
  };
}